// CANONICAL COPY (GH #7115). src/constants/obligations/obl-processing-instruction-compliance.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-processing-instruction-compliance',
  title: "Verify processing occurs only on the controller's documented instruction",
  description:
    "Confirm that the processor has written procedures requiring all personal-data processing to occur only on the controller's documented instruction (GDPR Art. 28(3)(a); FSR ISAE 3000 Kontrolmål A.1–A.2). Procedures shall cover receipt and logging of instructions, scope verification before processing begins, and prevention of processing outside instructed purposes. Review the processing-instruction standard, sample recent processing activities against the underlying DPA, and the annual procedure-review record.",
  category: 'compliance',
  scfIds: ['SCF-PRV-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Processing-instruction procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
